import { Navigate } from 'react-router';
import { useAuth } from "./authContext";


export const AuthGuard = ({ children }) => {
  const { auth } = useAuth();

  if (auth.currentUser === undefined) {
    return <div>Loading...</div>; // still loading
  }

  return auth.currentUser ? children : <Navigate to="/login" replace />;
};

